<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Merchant Profile" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div id="user-profile">
          <!-- profile header -->
          <div class="row">
            <div class="col-12">
              <div class="card profile-header mb-2">
                <!-- profile cover photo -->
                <img class="card-img-top" :src="`${publicPath}app-assets/images/profile/user-uploads/timeline2.png`"
                     alt="User Profile Image"/>
                <!--/ profile cover photo -->

                <div class="position-relative">
                  <!-- profile picture -->
                  <div class="profile-img-container d-flex align-items-center">
                    <div class="profile-img">
                      <div class="spinner-border text-primary " v-show="loader"></div>
                      <img :src="profileImage" class="rounded img-fluid" alt="Card image" :key="keyUpdate"/>
                      <div @click="$refs.UserProfileImage.click()">
                        <BIconPencilSquare style="position: absolute;top: 83%;right: 58%;" width="28" height="28"
                                           class="text-primary"/>
                        <input type="file"
                               ref="UserProfileImage"
                               @change="onFileChanged($event)"
                               style="display:none"/>
                      </div>
                    </div>


                    <div class="profile-title ml-3">
                      <h2 class="text-white">
                        {{
                          $store.getters.getLoggedInUser ? $store.getters.getLoggedInUser.first_name + ' ' + $store.getters.getLoggedInUser.last_name : ''
                        }}</h2>
                      <p class="text-white">Merchant</p>
                    </div>
                  </div>
                </div>

                <!-- tabs pill -->
                <div class="profile-header-nav">
                  <!-- navbar -->
                  <nav
                      class="navbar navbar-expand-md navbar-light justify-content-end justify-content-md-between w-100">
                    <button class="btn btn-icon navbar-toggler" type="button" data-toggle="collapse"
                            data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                            aria-expanded="false" aria-label="Toggle navigation">
                      <i data-feather="align-justify" class="font-medium-5"></i>
                    </button>

                    <!-- collapse  -->
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                      <div class="profile-tabs d-flex justify-content-between flex-wrap mt-1 mt-md-0">
                        <ul class="nav nav-pills mb-0">
                          <li class="nav-item m-2">
                            <div class="row"><span class="card-text font-medium-3 font-weight-bold">Email</span></div>
                            <div class="row"><span
                                class="card-text">{{
                                $store.getters.getLoggedInUser ? $store.getters.getLoggedInUser.email : ''
                              }}</span>
                            </div>
                          </li>
                          <li class="nav-item m-2 ml-4">
                            <div class="row"><span class="card-text font-medium-3 font-weight-bold mb-0">Contact</span>
                            </div>
                            <div class="row"><span
                                class="card-text">{{
                                $store.getters.getLoggedInUser ? $store.getters.getLoggedInUser.phone_number : ''
                              }}</span>
                            </div>
                          </li>
                          <li class="nav-item m-2 ml-4">
                            <div class="row"><span
                                class="card-text font-medium-3 font-weight-bold mb-0">Last Login</span></div>
                            <div class="row"><span
                                class="card-text">{{
                                $store.getters.getLoggedInUser ? new Date($store.getters.getLoggedInUser.last_login_at).toISOString().slice(0, 16).replace('T', ' ') : ''
                              }}</span>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <!--/ collapse  -->
                  </nav>
                  <!--/ navbar -->
                </div>
              </div>
            </div>
          </div>
          <!--/ profile header -->

        </div>




        <section id="page-account-settings">
          <div class="card">

         <div class="row">
           <div class="col-12">
             <div class="d-flex align-items-center mx-sm-1 mt-2">
               <BIconCart width="30" height="30" class="text-primary"/>
               <h4 class="mb-0 ml-75">Stores</h4>
             </div>
           </div>
         </div>

            <CommonTable
                url="v1/get-stores"
                :tableHeaderValues="storeHeaders"
                :useCustomRows="true"
                responseDataKey="stores"
                :actions="actions"
                :mutedData="mutedData"
                :filteredData="filteredData"
                @pageChange="resetAccordions"
            >
              <template #row="{ row, index, count }">
                <!-- Store Row -->
                <tr>
                  <td>{{ count + index + 1 }}</td>
                  <td>{{ row.name }}</td>
                  <td>{{ row.code }}</td>
                  <td>
                    <span v-if="row.status == 1" class="badge badge-light-success">Active</span>
                    <span v-else class="badge badge-light-danger">Inactive</span>
                  </td>
                  <td>
                    <button
                        @click="toggleStoreAccordion(index)"
                        class="btn btn-sm btn-warning"
                    >
                      <BIconChevronDown v-if="expandedStores.includes(index)" />
                      <BIconChevronRight v-else />
                      Terminals ({{ row.terminals?.length || 0 }})
                    </button>
                  </td>
                </tr>

                <!-- Terminals Accordion -->
                <tr v-if="expandedStores.includes(index)">
                  <td :colspan="5" class="p-0 ">
                    <div class="pl-4 pr-4 pt-2 pb-2">
                      <table class="table border-dark badge-glow">
                        <thead class="thead-dark">
                        <tr>
                          <th>S.No</th>
                          <th>Terminal Name</th>
                          <th>Code</th>
                          <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="(terminal, termIndex) in row.terminals" :key="terminal.id">
                          <tr>
                            <td>{{ termIndex + 1 }}</td>
                            <td>{{ terminal.name }}</td>
                            <td>{{ terminal.code }}</td>
                            <td>
                              <button
                                  @click="toggleTerminalAccordion(index, termIndex)"
                                  class="btn btn-sm btn-primary"
                              >
                                <BIconChevronDown v-if="expandedTerminals[`${index}-${termIndex}`]" />
                                <BIconChevronRight v-else />
                                Channels ({{ terminal.channels?.length || 0 }})
                              </button>
                            </td>
                          </tr>

                          <!-- Channels Accordion -->
                          <tr v-if="expandedTerminals[`${index}-${termIndex}`]">
                            <td :colspan="5" class="p-0 ">
                              <div class="pl-5 pr-4 pt-2 pb-2">
                                <table class="table table-sm border-dark">
                                  <thead class="thead-dark">
                                  <tr>
                                    <th>S.No</th>
                                    <th>Channel Name</th>
                                    <th>Code</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-for="(channel, channelIndex) in terminal.channels" :key="channel.id">
                                    <td>{{ channelIndex + 1 }}</td>
                                    <td>{{ channel.name }}</td>
                                    <td>{{ channel.code }}</td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </tr>
                        </template>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </template>
            </CommonTable>
          </div>
        </section>


      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import CommonTable from "@/components/common/CommonTable.vue";

export default {
  components: {CommonTable},
  computed: {
    ...mapState(['userProfilePicture'])
  },
  mounted() {
    if (this.userProfilePicture) {
      this.profileImage = this.userProfilePicture
    }
    // this.getUserFields()
    // this.getChannelData()
  },
  data() {
    return {
      breadcrumb: [
        {name: 'App'},
        {name: 'Profile'},
      ],
      userFields: [],
      profileImage: this.publicPath + 'images/avatar/avatar-user.png',
      keyUpdate: 2,
      renderComponent: true,
      loader: false,
      channelList: [],
      storeList: [],
      terminalList: [],
      storeHeaders: [
        { title: 'S.No', valueKey: 'index' },
        { title: 'Store Name', valueKey: 'name' },
        { title: 'Code', valueKey: 'code' },
        { title: 'Status', valueKey: 'status' },
        { title: 'Actions' }
      ],
      expandedRows: [],
      expandedTerminals: {},
      filteredData:{paginate:1},
      mutedData: [],
      actions:[],
      expandedStores: [],

    }
  },
  methods: {
    onFileChanged: function (event) {
      let file = event.target.files[0]
      this.submitFile(file)
      // if (typeof (file) != 'undefined') {
      //   this.getBase64(file).then( (response) => {
      //         this.submitFile(response)
      //      }
      //   )
      // }
    },
     getBase64(file) {
       return new Promise((resolve, reject) => {
         const reader = new FileReader();
         reader.readAsDataURL(file);
         reader.onload = () => resolve(reader.result);
         reader.onerror = error => reject(error);
       });
    },


    async submitFile(file) {
      // let data = new FormData();
      // data.append("profilePicture", file, file.name);
      // data.append("uri", 'v1/update-profile-picture');

      let data = {}

      let attachment = new FormData();
      attachment.append("profilePic", file);
      data.attachment = attachment

      this.loader = true
      this.makeRequest('post', 'v1/update-profile-picture', data).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.$store.dispatch('updateUserProfilePicture', callResponse.response.data.data.avatar)

          }
        }

        this.loader = false

      });

    },
    resolveUserImage() {

      let userData = this.$store.getters.getLoggedInUser
      if (userData) {
        if (userData.avatar) {
          return this.profileImage = userData.avatar
        }
      }
      return this.profileImage

    },
    resolveValue(value) {
      if (value == 1) {
        return 'Yes'
      } else if (value == 0) {
        return 'No'
      } else {
        return value
      }
    },
    getUserFields() {
      this.makeRequest('post', 'v1/get-user-data', {}, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.userFields = callResponse.response.data.data.userkycs
          }
        }

      });

    },
    async forceRerender() {
      // remove the my-component component from the DOM
      this.renderComponent = false;

      await this.$nextTick();
      this.renderComponent = true;
    },
    getChannelData() {
      this.makeRequest('post', 'v1/get-stores', {}, {}, false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          let responseData = callResponse.response.data.data
          if (code == 200) {
            if (responseData) {
              if (responseData.channels) {
                this.channelList = responseData.channels
              }
              if (responseData.stores) {
                this.storeList = responseData.stores
              }
              if (responseData.terminals) {
                this.terminalList = responseData.terminals
              }
            }

          }

        }


      });
    },

    handleStoreData(response) {
      // Handle pagination data if needed
      console.log('Received data:', response);
    },
    toggleStoreAccordion(index) {
      if (this.expandedStores.includes(index)) {
        this.expandedStores = this.expandedStores.filter(i => i !== index);
      } else {
        this.expandedStores.push(index);
      }
    },
    toggleTerminalAccordion(storeIndex, termIndex) {
      const key = `${storeIndex}-${termIndex}`;
      this.expandedTerminals = {
        ...this.expandedTerminals,
        [key]: !this.expandedTerminals[key]
      };
    },
    resetAccordions() {
      // Close all accordions when page changes
      this.expandedStores = [];
      this.expandedTerminals = {};
    },

  },
  watch: {
    userProfilePicture(val) {

      this.profileImage = localStorage.getItem('userProfilePicture')
      this.keyUpdate = Math.random()


    },

  }
}
</script>

